import { ApiError, errorMessage } from '../lib/api';
import { ErrorBox, Notice } from './ui';

/** Honest discovery failure states: unconfigured, quota, signed-out limit — never placeholder cards. */
export function DiscoveryError({ err, onRetry, compact = false }: { err: unknown; onRetry?: () => void; compact?: boolean }) {
  if (err instanceof ApiError && err.code === 'discovery_unconfigured') {
    return <div data-testid="discovery-error"><Notice tone="warning"><p><strong>Discovery isn’t available right now.</strong> {compact ? '' : err.message}</p></Notice></div>;
  }
  if (err instanceof ApiError && err.code === 'discovery_quota') {
    return <div data-testid="discovery-error"><Notice tone="warning"><p><strong>Search is resting.</strong> {err.message}</p></Notice></div>;
  }
  if (err instanceof ApiError && err.code === 'quota_exceeded' && (err.data.signIn === true)) {
    return <div data-testid="discovery-error"><Notice tone="info"><p><strong>You’ve reached today’s signed-out limit.</strong> <a href={`/login?next=${encodeURIComponent(location.pathname + location.search)}`}>Sign in for more searches</a>.</p></Notice></div>;
  }
  return <div data-testid="discovery-error"><ErrorBox message={errorMessage(err)} onRetry={onRetry} /></div>;
}

/** Trending chips. YouTube's mostPopular chart supports category ids; topics without a category use a search. */
export const TREND_CHIPS: { label: string; category?: string; q?: string }[] = [
  { label: 'All' }, { label: 'Travel', category: '19' }, { label: 'Nature', q: 'nature' }, { label: 'Music', category: '10' },
  { label: 'Technology', category: '28' }, { label: 'Food', q: 'food' }, { label: 'Documentary', q: 'documentary' }, { label: 'Gaming', category: '20' },
];

/** Treat pasted links as download candidates; everything else is a search. */
export function asUrl(raw: string): string | null {
  const v = raw.trim();
  if (/^https?:\/\/\S+$/i.test(v)) return v;
  if (/^(www\.|m\.)?(youtube\.com|youtu\.be|commons\.wikimedia\.org|upload\.wikimedia\.org)\/\S*$/i.test(v)) return `https://${v}`;
  return null;
}
